
import Vue from 'vue'
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import { Sequence } from '../../types/Sequence'
import { Rig } from '../../types/Rig'
import project from '@/store/modules/project';
import DateUtils from '@/types/DateUtils'
import printer from '@/print'
import ProjectHeatMap from './Modals/ProjectHeatMap.vue'
import projectSheet from './Modals/ProjectReport.vue'
import SwapStates from '../../utils/SwapState.js'
import { createPopper } from '@popperjs/core';
import UserProVisioning from "@/mixins/userProvisioning"
import convertUnit from '@/utils/convertUnit'
import SequencePrinter from '@/mixins/SequencePrinter'
import CMultiSelect from '@/components/CMultiSelect.vue'

let popperInstance = null as any;
let tooltip = null as any

@Component({
  components: {
    'project-sheet': projectSheet,
    'heat-map' : ProjectHeatMap,
    'cmultiselect': CMultiSelect
  },
  filters: {
    budget: (value: any) => {
      return "K$ " + parseFloat(value).toLocaleString();
    }
  }
})
export default class Chart extends Mixins(UserProVisioning, SequencePrinter) {
  convertUnits(value: any, typex:any, unit: any) {
    return convertUnit(value, typex, unit)
  }

  @Prop()
  readOnlyView!: any

  @Prop()
  sequenceId !: any

  @Prop()
  currentHeight !: any

  @Prop()
  currentWidth !: any

  @Prop()
  wellActivities?: any

  viewMode: string = "rig"

  showMailerForm = false
  activeHeatMapFile = null;
  showFundingMechnism = true
  showDeleteModal = false
  showWBS = false
  showLeaseFilter = false
  historyMode = false
  showHeatMap=false
  showProjectSheet = false
  filterId: any
  allowCascade: boolean = true
  selectedWellActivities: Array<any> = [];
  allowCascadeStateBackup: string = ""
  start: any = new Date()
  end: any = new Date(this.start.getFullYear() + 1, 11, 31)
  selectedLease: Array<any> = []
  selectAll: boolean = true
  projects: Array<any> = []
  filteredProjectsRigs: Array<any> = []

  timeArray: Array<any> = [
    { text: 'Year', value: 'YEAR' },
    { text: 'Month', value: 'MONTH' },
    { text: 'Week', value: 'WEEK' },
  ]

  projectSheetView: boolean = false

  // Undo-Redo Properties
  press: number = 1
  pressAss: number = 1
  pressDo: number = 0

  visibleTimeUnits: Array<any> = [
    {
      timeUnit: "CURRENT",
      options: {
        fill: 'yellow',
        textColor: 'blue',
        stroke: 'white'
      }
    },
    {
      timeUnit: "YEAR",
      options: {
        fill: this.settingsTime[0].color,
        textColor: 'white',
        stroke: 'white'
      }
    },
    {
      timeUnit: "MONTH",
      options: {
        fill: this.settingsTime[1].color,
        textColor: 'white',
        stroke: 'white'
      }
    },
    {
      timeUnit: "WEEK",
      options: {
        fill: this.settingsTime[2].color,
        textColor: 'white',
        stroke: 'white'
      }
    },
  ]

  timeUnit: string = 'WEEK'
  fillColorSetting: string = 'Funding Tranche'
  lineColorSetting: string = 'Well Type'

  defaultWell: any = {
    name: "Not Yet Selected",
    id: 0,
    wellType: 'DEFAULT'
  }

  defaultRig: any = {
    name: "Not Yet Selected",
    id: 0,
    terrain: 'DEFAULT'
  }

  rigs: Array<any> = []
  selected: Array<any> = []
  selectedWells: Array<any> = []
  sortedRigs: Array<any> = []
  sortedWells: Array<any> = []
  checkRigs: Array<any> = []
  checkWells: Array<any> = []

  info: any = {
    id: "",
    cost: "",
    actualCost: "",
    class: "",
    name: "",
    well:{},
    projectStatus: "",
    Objective: "",
    moveInProgress:false,
    copyInProgress: false,
    projectCopyState: "",
    funding:{},
    projectClass: {},
    projectCopyErrorMessage: "",
    resourceName: "",
    resourceId: "",
    rigTerrain: "",
    incommingResourceName: "",
    incomingResourceId: "",
    incommingStart: "",
    dailyReportActivityName: "",
    cloneInProgress:false,
    row:{},
    preProcesses: [] as Array<any>,
    deptDataIntegrity: [] as Array<any>,
    activities:[] as Array<any>,
    ddrs: [] as Array<any>
  }

  sequence: Sequence = {
    id: "",
    name: '',
    rigIds: [],
    rigs: [],
    departmentIds: [],
    departments: [],
    startYear: new Date().getFullYear(),
    endYear: new Date().getFullYear(),
    description: '',
    annualizedBudgets: [],
    riglessBuckets: [],
    userId: 0,
    cloneId: 0
  }

  tooltipFocused: boolean = false

  printStatus: any = {
    all: false,
    number: 1
  }

  get printRules() {
    const numberOfYears = this.sequenceObject.endYear - this.sequenceObject.startYear + 1
    if (!this.printStatus.all && (this.printStatus.number == 0 || this.printStatus.number > numberOfYears)) return true
    return false
  }

  get statusClass(){
    return () => {
      if(this.info.projectStatus){
          if(this.info.projectStatus === 'Ongoing'){       
            return {background: '#FFC107', color: '#fff'};
          }
          if(this.info.projectStatus === 'Completed'){       
            return {background: '#2eaa3e', color: '#fff'};
          }
          if(this.info.projectStatus === 'Pending'){       
            return {background: '#DC3545', color: '#fff'};
          }
          if(this.info.projectStatus === 'Suspended'){       
            return {background: '#d793d7', color: '#fff'};
          }
      }
      }
  }

  get applyClass () {
    return (result: any) => {
          if(result.preprocessValue){
              if(this.checkGreenCodeTask(result)){       
                return {background: '#2eaa3e'};
              }
              if(this.checkGrayCodeTask(result)){
                return {background: '#6C757D'};
              }
              if(this.checkYellowCodeTask(result)){
                return {background: '#FFC107'};
              }
              if(this.checkRedCodeTask(result)){
                return {background: '#DC3545'};
              }
          }
      }
  }

  get settings() {
    return this.$store.getters['settingsModule/getSettings']
  }

  get activeUser() {
    return this.$store.getters['activeUser']
  }

  get messageBody():string{
    let message = "\nSOMA DIAP NOTIFICATION,\n\n"+this.activeUser.firstName+' '+this.activeUser.lastName+
                        ' sent a file.'
    return message
  }

  get ganttData() {
    const data = { 
      projects: this.projects, 
      extractor: this.extractor, 
      rows: this.filteredProjectsRigs, 
      rowIdExtractor: (r:any) => r.id 
    }
    return data;
  }

  getUniqueLeaseIds(row: any) {
    const leaseIds = row.items
      .filter((x: any) => x.well && x.well.leaseId)
      .map((x: any) => x.well.leaseId);
    const uniqueIds = [...new Set(leaseIds)];
    return uniqueIds.join(', ');
  }

  toUnitSymbol(value: any,  system: any, fromUnit: any) {
    let unitsArray = this.$store.getters['UnitsModule/getUnits']
    let getQuantityFromUnits = this.$store.getters['UnitsModule/getQuantityFromUnits']
    let fromUnitt = unitsArray.find((unit: any) => unit.symbol === fromUnit)
    if (!fromUnitt) {
      return value;
    }
    let fromQuantityName = fromUnitt.quantity
    let fromQuantity = getQuantityFromUnits.find((quantity: any) => quantity.name === fromQuantityName)
    return fromQuantity.getBaseUnit(system)
  }

  planningCheckListStatus(name: string): boolean {
      if (!this.info.preProcesses || this.info.preProcesses.length === 0) {
          return false;
      }

      return this.info.preProcesses.every((process: any) => {
          if (!process.preprocessValue) return false;

          const dept = this.sequenceObject.departments.find((dept: any) => dept.id === process.departmentId);
          if (!dept || dept.name !== name) return false;

          switch (process.valueType.toLowerCase()) {
              case "boolean":
                  return process.preprocessValue.toLowerCase() === "yes";
              case "range":
              case "percentage":
                  return process.preprocessValue === 100;
              case "status":
                  return process.preprocessValue.toLowerCase() === "completed";
              default:
                  return false;
          }
      });
  }

  generateBarFillColor(data: any) {
    switch (this.fillColorSetting) {
      case 'Project Class':
        return data.projectClass ? this.getColorForProject(data.projectClass.name) : 'transparent'
      case 'Funding Tranche':
        return data.funding ? '#' + data.funding.lineColor : 'transparent';
      case 'Well Type':
        return data.well.wellType ? this.getWellColorForProject(data) : 'transparent'
    }
  }

  generateBarFillColor2(data: any) {
    switch (this.fillColorSetting) {
      case 'Project Class':
        return data.projectClass ? this.getColorForProject2(data.projectClass.name) : '#ffffff'
      case 'Funding Tranche':
        return data.funding ? '#' + data.funding.lineColor : '#ffffff';
      case 'Well Type':
        return data.well.wellType ? this.getWellColorForProject(data) : '#ffffff'
    }
  }
  
  generateBarTextColor(data: any) {
    switch (this.fillColorSetting) {
      case 'Project Class':
        return data.projectClass ? this.getTextColorForProject(data.projectClass.name) : this.getWellTextColorForProject(data)
      case 'Funding Tranche':
        return data.funding ? '#' + data.funding.textColor : this.getWellTextColorForProject(data);
      case 'Well Type':
        return data.well && data.well.wellType ? this.getWellTextColorForProject(data) : '#000'
    }
  }

  generateBarLineColor(data: any) {
    switch (this.lineColorSetting) {
      case 'Project Class':
        return data.projectClass ? data.projectClass.lineColor : 'transparent'
      case 'Funding Tranche':
        return data.funding ? '#' + data.funding.lineColor : 'transparent';
      case 'Well Type':
        return data.well && data.well.wellType ? this.getWellColorForProject(data) : 'transparent'
    }
  }

  computePrintSections(projectToSection: any) {
    let visibleActivityIds: Array<any> = []
    if (projectToSection.activities && projectToSection.activities.length > 0) {
      let sections: Array<any> = []
      let totalDays = this.computeDuration(projectToSection.start, projectToSection.end)
      let activitiesToProcess: Array<any> = []
      projectToSection.activities.filter((a: any) => a.departmentId == 3).forEach((a: any) => {
        const activityStartDate = new Date(a.start)
        const activityEndDate = new Date(a.end)
        const projectStartDate = new Date(projectToSection.start)
        const projectEndDate = new Date(projectToSection.end)
        if (activityStartDate.getTime() <= projectEndDate.getTime() && activityEndDate.getTime() > projectStartDate.getTime()) {
          activitiesToProcess.push({ ...a, start: activityStartDate.getTime() < projectStartDate.getTime() ? projectStartDate : activityStartDate, end: activityEndDate.getTime() > projectEndDate.getTime() ? projectEndDate : activityEndDate })
        }
      })

      activitiesToProcess.sort((a1: any, a2: any) => {
        const a1Start = new Date(a1.start).getTime()
        const a2Start = new Date(a2.start).getTime()
        return a1Start - a2Start
      }).forEach((a: any) => {
        visibleActivityIds.push(a.wellActivity.id)
        let sectionDays = this.computeDuration(a.start, a.end)
        sections.push({ color: '#' + a.wellActivity.color, width: sectionDays, activityName: a.wellActivity.name })
      })
      this.$emit('visible-activities-changed', visibleActivityIds)
      return sections
    } else {
      return []
    }
  }

  getDateDifferenceInDays(startDate: any, endDate: any) {
    if (typeof (startDate) == 'string') {
      return Math.floor((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 3600 * 24))
    } else {
      return Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24))
    }
  }

  checkGreenCodeTask(preprocess:any):boolean{
      let results = ["Yes","COMPLETED","100"]
      if((preprocess.maxValue == 0 && preprocess.minValue==0 && results.includes(preprocess.preprocessValue))||
          (preprocess.maxValue>preprocess.minValue && preprocess.maxValue== preprocess.preprocessValue)){
              return true
      }
      return false
  }

  checkRedCodeTask(preprocess:any):boolean{
      let results = ["No","AT_RISK","0"]
      if((preprocess.maxValue == 0 && preprocess.minValue==0 && results.includes(preprocess.preprocessValue))||
          (preprocess.maxValue>preprocess.minValue &&  preprocess.preprocessValue<=preprocess.minValue)){
              return true
      }
      return false
  }

  checkYellowCodeTask(preprocess:any):boolean{
      let results = ["IN PROGRESS"]
      if((preprocess.maxValue == 0 && preprocess.minValue==0 && (preprocess.preprocessValue== "IN PROGRESS" || (preprocess.preprocessValue<100 &&preprocess.preprocessValue>0))) ||
          (preprocess.maxValue>preprocess.minValue && preprocess.maxValue > preprocess.preprocessValue && preprocess.minValue < preprocess.preprocessValue )){
              return true
      }
      return false
  }

  checkGrayCodeTask(preprocess:any):boolean{
      if(preprocess.preprocessValue == "SUSPENDED"){
          return true
      }
      return false
  }

  destroyTooltip() {
    tooltip.removeAttribute('data-show');
    if (popperInstance) {
      popperInstance.destroy();
      popperInstance = null;
    }
  }

  toolTipLostFocus() {
    this.tooltipFocused = false;
    this.destroyTooltip()
  }

  startProjectMove(){
    this.info.moveInProgress = true
    this.$bvToast.toast('Project move ready.', {
      title: 'Please Note!!!',
      autoHideDelay: 5000,
      appendToast: true,
      toaster: 'b-toaster-bottom-right',
      solid: true,
      variant: 'success'
    })
    this.destroyTooltip()
  }

  startProjectClone(){
    this.info.cloneInProgress = true
    this.$bvToast.toast('Project clone ready.', {
      title: 'Please Note!!!',
      autoHideDelay: 5000,
      appendToast: true,
      toaster: 'b-toaster-bottom-right',
      solid: true,
      variant: 'success'
    })
    this.destroyTooltip()
  }

  doProjectMoveCancel() {
    this.info.copyInProgress = false
    this.$bvModal.hide("project-move-modal")
  }

  doProjectCloneCancel(){
    this.info.cloneInProgress = false
    this.$bvModal.hide("project-clone-modal")
  }

  doProjectMove() {
    this.info.copyInProgress = false
    let projectToMove = this.projects.find((p: any) => p.id == this.info.id)

    if (this.info.resourceId != this.info.incomingResourceId) {
      if (this.info.resourceType == "RIG") {
        let rigToSwapTo = this.sequenceObject.rigs.find((r: any) => this.info.incomingResourceId == r.id)
        this.$store.commit("projectModule/updateProject", { sequenceId: this.sequenceObject.id, id: this.info.id, rig: rigToSwapTo })
      } else {
        let riglessBucketToSwapTo = this.sequenceObject.riglessBuckets.find((r: any) => this.info.incomingResourceId == r.id)
        this.$store.commit("projectModule/updateProject", { sequenceId: this.sequenceObject.id, id: this.info.id, riglessBucket: riglessBucketToSwapTo })
      }
    }
    let newEndDate: any = this.addDays(this.info.incommingStart, this.computeDuration(projectToMove.start, projectToMove.end));
    newEndDate = newEndDate.getFullYear() + "-" + ((newEndDate.getMonth() + 1) < 10 ? ('0' + (newEndDate.getMonth() + 1)) : newEndDate.getMonth() + 1) + "-" + (newEndDate.getDate() < 10 ? ('0' + newEndDate.getDate()) : newEndDate.getDate())
    this.chartOptions.constraints.cascadeEast = false;
    this.$nextTick(() => {
      this.$store.commit("projectModule/updateProject", { sequenceId: this.sequenceObject.id, id: this.info.id, start: this.info.incommingStart, end: newEndDate })
      this.chartOptions.constraints.cascadeEast = false;
      this.$bvModal.hide("project-move-modal")
    })
  }

  doProjectClone(){
    this.info.cloneInProgress = false
    let projectToClone = this.projects.find((p:any) => p.id == this.info.id)
    let daysDifference = this.getDateDifferenceInDays(projectToClone.start,this.info.incommingStart)
    let newEndDate:any = this.addDays(this.info.incommingStart,this.computeDuration(projectToClone.start,projectToClone.end));
    this.drawingEnd({
      startDate:new Date(this.info.incommingStart),
      endDate:newEndDate,
      row:this.info.row
    })
    const createdProject = this.projects[this.projects.length-1]
    projectToClone.activities.forEach((a:any) => {
      this.$store.dispatch("ActivityModule/addActivity",{sequenceId:this.sequenceId,projectIndex:this.projects.length-1 ,newActivity:{
        name:a.name,
        departmentId:a.departmentId,
        start: this.addDays(a.start,daysDifference),
        end: this.addDays(a.end,daysDifference),
        milestones:a.milestones.map((m:any) => ({id:m.id,name:m.name})),
        wellActivity:a.wellActivity,
        supportTeamsIds:a.supportTeamsIds,
      }})
      const createdActivity = this.projects[this.projects.length-1].activities[createdProject.activities.length-1]
      this.$store.dispatch("MilestoneModule/getAndCreateMilestonesForActivity",{activityId:createdActivity.id,sourceActivityId:a.id,days:daysDifference,hasServerData:(a.milestones.length>0)})
      
      if(a.budget&&a.budget!=null){
        this.$store.dispatch("ActivityModule/updateActivityBudget",{projectIndex:this.projects.length-1,projectId:projectToClone.id,sequenceId:this.sequenceId,id:createdActivity.id,budgetTemplateId:a.budget.budgetTemplateId})
        a.budget.budgetLines.forEach((bl:any) => {
          this.$store.dispatch('ActivityModule/updateActivityBudget',{sequenceId:this.sequenceId,projectIndex:this.projects.length-1,id:createdActivity.id,sectionId:"",lineItem:{lineValue:bl.lineValue,lineItemId:bl.lineItemId}})
        });
      }
      
    });
    this.$bvModal.hide('project-clone-modal')
  }

  deleteAllProjects() { 
    this.$store.commit("setRightPaneToFalse")
    let tempList = this.projects.slice()
    for (let index = 0; index < tempList.length; index++) {
      this.$store.commit('projectModule/deleteProject', tempList[index])     
    }
  }

  getPlanBudgetForProject(activities: Array<any>, project:any) {
    let totalBudget = 0
    if (project.costOption === 'LineItem') {
      if (!activities.length) return 0
          activities.forEach((activity: any) => {
            if(activity.budget){
              activity.budget.budgetLines.forEach((budgetLine: any) => {
                totalBudget += budgetLine.lineValue
              })
            }
        });
      }
      else if (project.costOption === 'LumpCost') {
        if (!project.departmentBudgets && !project.departmentBudgets.length) return 0
        project.departmentBudgets.forEach((d:any) => {
          totalBudget += d.approvedBudget
        });
        // const deptIds = this.sequenceObject.departments.map((d: any) => d.id);
        // const departments = this.getDepartmentOptions.filter((d: any) => deptIds.includes(d.id));
        // totalBudget = departments.map((d: any) => d.approvedBudget).reduce((a: any, b: any) => a + b, 0); 
      }
      else if (project.costOption === 'DailyCost') {
          totalBudget = project.approvedAFEBudget;
      }
      else if (project.costOption === 'ProjectCost') {
        if(project.approvedBudget && project.approvedBudget !== null){
            project.approvedBudget.budgetLines.forEach((budgetLine:any) => {
              totalBudget += budgetLine.lineValue
            })
          }
      }
      return totalBudget
    }

  getActualCost(activities: Array<any>, project: any) {
    let totalBudget = 0
    if (project.costOption === 'LineItem') {
      if (!activities.length) return 0
        activities.forEach((activity: any) => {
          if(activity.actualCost){
            activity.actualCost.budgetLines.forEach((budgetLine: any) => {
              totalBudget += budgetLine.lineValue
            })
          }
      });
    }
    else if (project.costOption === 'LumpCost') {
        if (!this.sequenceObject && !this.sequenceObject.departments.length) return 0
        const deptIds = this.sequenceObject.departments.map((d: any) => d.id);
        const departments = this.getDepartmentOptions.filter((d: any) => deptIds.includes(d.id));
        totalBudget = departments.map((d: any) => d.actualCost).reduce((a: any, b: any) => a + b, 0); 
    }
    else if (project.costOption === 'DailyCost') {
        totalBudget = project.afeCost;
    }
    else if (project.costOption === 'ProjectCost') {
        if(project.actualBudgetCost && project.approvedBudget !== null){
            project.actualBudgetCost.budgetLines.forEach((budgetLine:any) => {
              totalBudget += budgetLine.lineValue
            })
          }
      }
    return totalBudget
  }

  getDeptdataState(dept: any, project: any) {
    let hasPendingBudgetData = true
    let hasPendingBudgetUpload = true

    project.activities.forEach((a: any) => {
      let activityOperationBelongToDept = dept.operationUnits.find((t: any) => t.id == a.operationUnitId)
      if (activityOperationBelongToDept) {
        if (a.budget) {
          hasPendingBudgetData = false
          if (this.budgetFiles.findIndex(b => b.operationUnitId == a.operationUnitId && b.projectId == project.id) > -1) {
            hasPendingBudgetUpload = false
          } else {
            hasPendingBudgetUpload = true
          }
        } else {
          hasPendingBudgetData = true
        }
      }
    })
    return hasPendingBudgetData || hasPendingBudgetUpload

  }
  get reportForProject() {
    return (projectId: any) => {
      this.$store.dispatch(
          "DailyReportModule/getReportsForProject",
          projectId
      )
    }
  }

  get ddrs() {
    return (projectId: any) => {
      return this.$store.getters["DailyReportModule/getReportsForProject"](projectId);
    }
  }

  barMouseEnter(data: any) {
    if (this.info.copyInProgress) return
    this.tooltipFocused = true;
    let hoveredProject = this.projects.find((p: any) => p.id == data.id)
    if (this.ddrs(hoveredProject.id).length < 1) {
      this.reportForProject(hoveredProject.id)
    }
    const ddrs = this.ddrs(hoveredProject.id)
    const sortedReport = ddrs.slice().sort((a:any, b:any) => {
        const dateA = new Date(a.reportDate);
        const dateB = new Date(b.reportDate);
        return dateA.getTime() - dateB.getTime();
      });
    const lastReport = sortedReport[sortedReport.length - 1];
    if (lastReport && lastReport.activityLog && lastReport.activityLog.length > 0) {
        const lastLog = lastReport.activityLog[lastReport.activityLog.length - 1];
        this.info.dailyReportActivityName = lastLog.activityName;
    }
    else {
      this.info.dailyReportActivityName = "" 
    }

    this.info.projectStatus = hoveredProject.projectStatus
    this.info.id = hoveredProject.id
    this.info.start = hoveredProject.start
    this.info.cost = this.getPlanBudgetForProject(hoveredProject.activities, hoveredProject)
    this.info.actualCost = this.getActualCost(hoveredProject.activities, hoveredProject)
    this.info.name = hoveredProject.name
    this.info.funding = hoveredProject.funding
    this.info.projectClass = hoveredProject.projectClass
    this.info.objective = hoveredProject.objective
    this.info.class = hoveredProject.projectClass ? hoveredProject.projectClass.name : ''
    this.info.preProcesses =  hoveredProject.preProcesses?hoveredProject.preProcesses:[]
    this.info.well = hoveredProject.well
    this.info.activities = hoveredProject.activities
    this.info.deptDataIntegrity = this.sequenceObject.departments.map((d: any) => ({ name: d.name, state: this.getDeptdataState(d, hoveredProject) }))
    if (hoveredProject.rig != null) {
      this.info.resourceId = hoveredProject.rig.id
      this.info.resourceName = hoveredProject.rig.name
      this.info.resourceType = "RIG"
      this.info.rigTerrain = hoveredProject.rig.terrain
    } else {
      this.info.resourceId = hoveredProject.riglessBucket.id
      this.info.resourceName = hoveredProject.riglessBucket.alias
      this.info.resourceType = "RIGLESS"
    }

    const bar = (this.$refs[data.id] as any).$el
    tooltip.setAttribute('data-show', '');
    popperInstance = createPopper(bar, tooltip, {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
  }

  barMouseLeave() {
    if (!this.tooltipFocused) this.destroyTooltip()
  }

  computeStroke(funding: any) {
    if (funding == null) {
      return { color: '', type: '' }
    } else {
      return { color: '#' + funding.lineColor, type: funding.lineStyle.toLowerCase() }
    }
  }

  computeDuration(start: string, end: string): number {
    if (!start || !end) return 0;

    const startDateMill = new Date(start).getTime();
    const endDateMill = new Date(end).getTime();

    const diff = endDateMill - startDateMill;
    if (diff < 1) return 0;

    return Math.round(diff / (1000 * 3600 * 24));
  }

  computeColor(project: any, activity: any) {
    if (project.Id === activity.ProjectId) return project.lineColor;
    return activity.wellActivity.color
  }

  computeSections(projectToSection: any): Array<any> {
    if (!projectToSection.activities || projectToSection.activities.length === 0) {
      return [];
    }
    let projects: Array<any> = [];
    let visibleActivityIds: Array<any> = [];
    let sections: Array<any> = [];
    let totalDays = this.computeDuration(projectToSection.start, projectToSection.end);
    const sortedList = [...projectToSection.activities].sort((a: any, b: any) => {
      return new Date(a.start).getTime() - new Date(b.start).getTime();
    });
    if (!projects.find((project) => project.id === projectToSection.id)) {
      projects.push({
        id: projectToSection.id,
        lineColor: this.generateBarFillColor(projectToSection)
      });
    }
    sortedList.forEach((a: any) => {
      if (a.wellActivity) {
        visibleActivityIds.push(a.wellActivity.id);
        let sectionDays = Math.round((this.computeDuration(a.start, a.end) / totalDays) * 100);
        const project = projects.find((x: any) => x.id === a.projectId)
        const color: string = project && project.lineColor ? `${project.lineColor}` : '';
        sections.push({ id: a.wellActivity.id, color: color, width: sectionDays });
        if (this.selectedWellActivities.some((activity: any) => activity.id === a.wellActivity.id)) {
          const section = sections.find(x => x.id === a.wellActivity.id);
          section.color = '#' + a.wellActivity.color;
        }
      }
    });
    this.$emit('visible-activities-changed', visibleActivityIds)
    return sections
  }

  computeSections2(projectToSection: any): Array<any> {
      if (!projectToSection.activities || projectToSection.activities.length === 0) {
          return [];
      }
      let projects: Array<any> = [];
      let visibleActivityIds: Array<any> = [];
      let sections: Array<any> = [];
      let totalDays = this.computeDuration(projectToSection.start, projectToSection.end);

      const sortedList = [...projectToSection.activities].sort((a: any, b: any) => {
          return new Date(a.start).getTime() - new Date(b.start).getTime();
      });
      let lastColor = ''
      if (!projects.find((project) => project.id === projectToSection.id)) {
          projects.push({
              id: projectToSection.id,
              lineColor: this.generateBarFillColor(projectToSection)
          });
          lastColor = this.generateBarFillColor(projectToSection);
      }

      let cumulativeWidth = 0; // Tracks cumulative width of 
      sortedList.forEach((activity: any) => {
          if (activity.wellActivity) {
              visibleActivityIds.push(activity.wellActivity.id);

              // Calculate the start offset and width of the section
              let activityStart = new Date(activity.start).getTime();
              let activityEnd = new Date(activity.end).getTime();
              let projectStart = new Date(projectToSection.start).getTime();

              let startOffset = Math.round(
                  (this.computeDuration(projectToSection.start, activity.start) / totalDays) * 100
              );
              let sectionWidth = Math.round(
                  (this.computeDuration(activity.start, activity.end) / totalDays) * 100
              );
              
              // Add a gap if needed
              if (startOffset > cumulativeWidth) {
                  sections.push({
                      id: null,
                      color: lastColor, // Default or transparent color
                      width: startOffset - cumulativeWidth
                  });
              }

              // Add the activity section
              const project = projects.find((x: any) => x.id === activity.projectId);
              const color: string = project && project.lineColor ? `${project.lineColor}` : '';
              sections.push({
                  id: activity.wellActivity.id,
                  color: color,
                  width: sectionWidth
              });

              // Update the cumulative width
              cumulativeWidth = startOffset + sectionWidth;

              // Update color for selected activities
              if (this.selectedWellActivities.some((act: any) => act.id === activity.wellActivity.id)) {
                  const section = sections.find(x => x.id === activity.wellActivity.id);
                  section.color = '#' + activity.wellActivity.color;
              }
          }
      });

      // Handle any remaining gap at the end
      if (cumulativeWidth < 100) {
          sections.push({
              id: null,
              color: lastColor, // Default or transparent color
              width: 100 - cumulativeWidth
          });
      }

      this.$emit('visible-activities-changed', visibleActivityIds);
      return sections;
  }


  get_report_projects() {
    let allprojects = this.projects
    var crossing_projects = allprojects.filter((x: any) => new Date(x._start).getFullYear() != new Date(x._end).getFullYear())
    crossing_projects.map((x: any) => x.is_crossing = true)
    allprojects.push(...crossing_projects);
    return allprojects;
  }

  getProjectsForRig(rigId: any, projects: any) {
    return projects.filter((project: any) => {
      return !project.isRigless && project.rig.id == rigId
    })
  }
  getProjectsForRigless(riglessId: any, projects: any) {
    return projects.filter((project: any) => {
      return project.isRigless && project.riglessBucket.id == riglessId
    })
  }

  getProjectsForYear(consideredDate: any) {
    var maxDateFromYear = new Date(consideredDate.getFullYear() + 1, consideredDate.getMonth(), 1)
    return this.projects.filter((x: any) => !x.is_rig_move).filter((project: any) => {
      let actualProjectStart = new Date(project.start)
      if (project.rigMoveDays != undefined && project.rigMoveDays != 0) {
        actualProjectStart.setDate(actualProjectStart.getDate() - (project.rigMoveDays + 1))
      }
      return (actualProjectStart < maxDateFromYear) && ((new Date(project.end)) > consideredDate)
    })
  }

  startProjectCopy() {
    this.info.copyInProgress = true
    this.$bvToast.toast('Project clone ready.', {
      title: 'Please Note!!!',
      autoHideDelay: 1000,
      appendToast: true,
      toaster: 'b-toaster-bottom-right',
      solid: true,
      variant: 'success'
    })
  }

  get currentUnitSystem(){
      return this.$store.getters['UnitsModule/getCurrentUnitSystem']
  }

  get chartOptions() {
    return {
      legend: true,
      constraints: {
        casecadeWest: false,
        cascadeEast: true,
        allowInteraction: this.readOnlyView ? false : { checkType: this.historyMode ? '' : 'START_AFTER' },
        boundWest: true,
        boundEast: true,
        allowDrawing: !this.readOnlyView
      }
    }
  }

  get extractor() {
    if (this.viewMode == 'rig') return (p: any) => p.isRigless ? p.riglessBucket : p.rig
    return (p: any) => p.well
  }

  @Watch("sequenceObject",{immediate: true})
  onSequenceObjectChange() {
    if (!this.sequenceObject || !Object.keys(this.sequenceObject).length) return;
    if (this.sequenceObject.fillColor) {
      this.fillColorSetting = this.sequenceObject.fillColor
    }
    
    if (this.sequenceObject.lineColor) {
      this.lineColorSetting = this.sequenceObject.lineColor
    }

    this.$emit('color-setting', this.fillColorSetting)
    this.$emit('line-setting', this.lineColorSetting)
  }

  updateSequence() {
    this.sequence = this.sequenceObject;
    this.sequence.rigIds = this.sequenceObject.rigs.map((rig: any) => rig.id);
    this.sequence.departmentIds = this.sequenceObject.departments.map((dept: any) => dept.id);
    this.$store.dispatch('sequencesModule/edit', this.sequence)
  }
  
  setColor() {
    this.sequenceObject.fillColor = this.fillColorSetting
    this.sequenceObject.lineColor = this.lineColorSetting

    this.$emit('color-setting', this.fillColorSetting)
    this.$emit('line-setting', this.lineColorSetting)
    this.updateSequence()
  }

  updateFilteredRigs(newRows: any) {
    if (this.viewMode == 'rig') {
      this.sortedRigs = newRows;
      const rigs = this.sortedRigs.filter(x => x.resourceType.toLowerCase() === 'rig')
      this.sequenceObject.rigs = rigs;
      this.sequence = this.sequenceObject;
      this.sequence.rigIds = this.sequenceObject.rigs.map((rig: any) => rig.id);
      this.sequence.departmentIds = this.sequenceObject.departments.map((dept: any) => dept.id);
      this.$store.dispatch('sequencesModule/edit', this.sequence)

    } else {
      this.sortedWells = newRows;
    }
  }

  get filteredRigs() {
    let rigsToReturn: Array<any> = []
    this.selected.forEach((thisCheckedRig, indexo, thisArray) => {
      let valToUse = thisCheckedRig <= indexo ? thisCheckedRig : indexo
      rigsToReturn.splice(valToUse, 0, this.viewMode == 'rig' ? this.sortedRigs[thisCheckedRig] : this.sortedWells[thisCheckedRig])
    })
    return rigsToReturn;
  }

  get allProjects() {
    return this.$store.getters['projectModule/getProjectsForSequence'](this.sequenceId)
  }

  get leaseIds() {
    const uniqueLeaseIds = [...new Set(this.allProjects.map((project: any) => project.well.leaseId))];
    return uniqueLeaseIds;
  }

  get getProjectChangesValidity() {
    return this.$store.getters['projectModule/getProjectChangesValidity']
  }

  get sidenav(): any {
    return this.$store.getters['getSideNavStatus']
  }
  get rightPane(): any {
    return this.$store.getters['getPaneStatus']
  }

  get sequenceObject() {
    return this.$store.getters['sequencesModule/getSequence'](this.sequenceId)
  }

  get rigById() {
    return this.$store.getters['rigsModule/getRigById']
  }

  get getAllrigs() {
    return this.$store.getters['rigsModule/getAllrigs']
  }

  get getDepartmentOptions() {
    return this.$store.getters['departmentModule/getAllDepartments']
  }

  get settingsTime() {
    return this.$store.getters['settingsModule/getTimeSettings']
  }
  get settingsRig() {
    return this.$store.getters['settingsModule/getSettingsRig']
  }
  get settingswellFluid(): Array<any> {
    return this.$store.getters['settingsModule/getSettingsWell']
  }
  get settingsProject(): Array<any> {
    return this.$store.getters['settingsModule/getSettingsProject']
  }
  get fetchColorSettings() {
    return this.$store.dispatch('settingsModule/getColorSettings')
  }

  get totalBudgetForProject() {
    let totalBudget = 0
    this.projects.forEach((project: any) => {
      if (project.activities.length){
        project.activities.forEach((activity: any) => {
          if (activity.budget) {
            activity.budget.budgetLines.forEach((budgetLine: any) => {
              totalBudget += budgetLine.lineValue
            })
          }
        });
      }

      if (project.departmentBudgets && project.departmentBudgets.length) {
        project.departmentBudgets.forEach((d:any) => {
          totalBudget += d.approvedBudget
        });
      }

      if (project.approvedAFEBudget && project.approvedAFEBudget !== null)
        totalBudget += project.approvedAFEBudget;

      if (project.approvedBudget && project.approvedBudget !== null) {
        project.approvedBudget.budgetLines.forEach((budgetLine: any) => {
          totalBudget += budgetLine.lineValue
        })
      }
    })
    return totalBudget
  }


  get budgetFiles(): Array<any> {
    return this.$store.getters["BudgetModule/getBudgetUploadMetas"](this.info.id)
  }

  //methods
  takeRightPane(data: any) {
    if (this.info.copyInProgress) {
      if (this.info.resourceType == data.row.resourceType) {
        this.info.incommingStart = data.start.getFullYear() + "-" + ((data.start.getMonth() + 1) < 10 ? ('0' + (data.start.getMonth() + 1)) : data.start.getMonth() + 1) + "-" + (data.start.getDate() < 10 ? ('0' + data.start.getDate()) : data.start.getDate())
        this.info.incomingResourceId = data.row.id

        if (this.info.resourceType == "RIG") {
          if ((this.info.rigTerrain == data.row.terrain) || data.row.terrain == "Amphibious" || this.info.rigTerrain == "Amphibious") {
            this.info.incommingResourceName = data.row.name
            this.info.projectCopyState = "PASTE_SUCCESS"
          } else {
            this.info.projectCopyState = "ERROR"
            this.info.projectCopyErrorMessage = "Source Terrain and destination terrain do match, please check your paste area and try again"
          }
        } else {
          this.info.incommingResourceName = data.row.alias
          this.info.projectCopyState = "PASTE_SUCCESS"
        }
        this.$bvModal.show("project-move-modal")
      } else {
        this.info.projectCopyState = "ERROR"
        this.info.projectCopyErrorMessage = "Source Terrain and destination terrain do match, please check your paste area and try again"
        this.$bvModal.show("project-move-modal")
      }
    } else {
      return this.$store.commit('setRightPaneToFalse')
    }
  }

  timeLabelClick() {
    if (this.sequenceObject) {
      this.$store.commit("setDynamicStart", new Date(this.sequenceObject.startYear, 0, 1))
      this.$store.commit("setDynamicEnd", new Date(this.sequenceObject.endYear, 11, 31))
    }
    this.$store.commit('setActivePane', 'time-units-component');
    this.$store.commit('setRightPaneToTrue');
  }

  getRigs() {
    return this.$store.dispatch('rigsModule/getRigs')
  }

  drawingStart(data: any) {
    if (!this.canWriteSequence) {
      this.chartOptions.constraints.allowDrawing = false;
      return;
    }
    if (this.readOnlyView) return
    let date = new Date(data.startDate)
    let today = new Date()

    if ((date < today) && (!this.historyMode)) {
      if (this.chartOptions.constraints.allowDrawing) {
        this.chartOptions.constraints.allowDrawing = false
        this.$bvToast.toast('You are attempting to draw a project in the past. Project start date must be greater than today.', {
          title: 'Please Note!!!',
          autoHideDelay: 10000,
          appendToast: true,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          variant: 'danger'
        })
      }
    } else {
      this.chartOptions.constraints.allowDrawing = true
    }
  }

  drawingEnd(data: any) {
    let isRigless = false
    var riglessBucket = null;
    var rig = null;
    var well = null;
    var name = "Project " + this.projects.length;
    let projectType = "DRILLING"

    if (this.viewMode == 'rig') {
      isRigless = data.row.resourceType == "RIGLESS"
      if (isRigless) {
        riglessBucket = data.row
        projectType = "INTERVENTION"
      } else {
        rig = data.row
      }
      well = this.defaultWell
    } else {
      well = data.row
      name = data.row.name
      rig = this.defaultRig
    }

    this.$store.commit("projectModule/addProject", {
      name,
      rig,
      riglessBucket,
      projectType,
      start: data.startDate.getFullYear() + "-" + ((data.startDate.getMonth() + 1) < 10 ? ('0' + (data.startDate.getMonth() + 1)) : data.startDate.getMonth() + 1) + "-" + (data.startDate.getDate() < 10 ? ('0' + data.startDate.getDate()) : data.startDate.getDate()),
      end: data.endDate.getFullYear() + "-" + ((data.endDate.getMonth() + 1) < 10 ? ('0' + (data.endDate.getMonth() + 1)) : data.endDate.getMonth() + 1) + "-" + (data.endDate.getDate() < 10 ? ('0' + data.endDate.getDate()) : data.endDate.getDate()),
      well,
      activities: [],
      funding: null,
      projectClass: null,
      wellType: null,
      sequenceId: this.sequenceId,
      isRigless,
      textColor: "white",
    })
  }

  get projectChanges() {
    return this.$store.getters['projectModule/getProjectChanges']
  }

  sendHeatMapInMail(data:any){
    this.showHeatMap = false
    this.showMailerForm = true
    this.activeHeatMapFile = data.file
  }

  addDays(date: string, daysToAdd: any) {
    var result = null
    if (typeof (date) == "string") {
      let splitedDate = date.split('-')
      result = new Date(Number.parseInt(splitedDate[0]), Number.parseInt(splitedDate[1]) - 1, Number.parseInt(splitedDate[2]));
    } else {
      result = date
    }
    if (daysToAdd == "") return result
    result.setDate(result.getDate() + Number.parseInt(daysToAdd));
    return result;
  }


  barMoveEnded(data: any) {
    data.startDate = data.startDate.getFullYear() + "-" + ((data.startDate.getMonth() + 1) < 10 ? ('0' + (data.startDate.getMonth() + 1)) : data.startDate.getMonth() + 1) + "-" + (data.startDate.getDate() < 10 ? ('0' + data.startDate.getDate()) : data.startDate.getDate())
    data.endDate = data.endDate.getFullYear() + "-" + ((data.endDate.getMonth() + 1) < 10 ? ('0' + (data.endDate.getMonth() + 1)) : data.endDate.getMonth() + 1) + "-" + (data.endDate.getDate() < 10 ? ('0' + data.endDate.getDate()) : data.endDate.getDate())
    this.$store.commit("projectModule/updateProject", { sequenceId: this.sequenceId, id: data.id, start: data.startDate, end: data.endDate })
  }

  changeTimeUnit(input: string) {
    this.timeUnit = input
  }

  doubleClick(proj: any) {
    this.destroyTooltip()
    this.$emit('change-active-view', { view: "activities", projectId: proj.id })
  }

  clickEvent(projId: any) {
    this.$store.commit('projectModule/setActiveProject', projId);
    this.$store.commit('projectModule/setActiveSequence', { sequenceId: this.sequenceId, readOnly: this.readOnlyView, viewMode: this.viewMode });
    this.$store.commit('setActivePane', 'info-cost');
    this.$store.commit('setRightPaneToTrue');
  }

  getColorForProject(data: any) {
    const setting = this.settingsProject.find(x => x.propertyName.toLowerCase() === data.toLowerCase());
    if (setting) {
      return setting.backgroundColor;
    }
    return 'transparent';
  }

  getColorForProject2(data: any) {
    const setting = this.settingsProject.find(x => x.propertyName.toLowerCase() === data.toLowerCase());
    if (setting) {
      return setting.backgroundColor;
    }
    return '#ffffff';
  }

  getTextColorForProject(data: any) {
    const setting = this.settingsProject.find(x => x.propertyName.toLowerCase() === data.toLowerCase());
    if (setting) {
      return setting.textColor;
    }
    return '#000000';
  }

  getWellColorForProject(data: any) {
    const setting = this.settingswellFluid.find(x => x.propertyName.toLowerCase() === data.well.wellType.toLowerCase());
    if (setting) {
      return setting.backgroundColor;
    }
    return '#FF0000';
  }

  getWellColorForProject2(data: any) {
    const setting = this.settingswellFluid.find(x => x.propertyName.toLowerCase() === data.toLowerCase());
    if (setting) {
      return setting.backgroundColor;
    }
    return '#000000';
  }
  
  getWellTextColorForProject(data: any) {
    if (!data.well) return '#000000';
    const setting = this.settingswellFluid.find(x => x.propertyName.toLowerCase() === data.well.wellType.toLowerCase());
    if (setting) {
      return setting.textColor;
    }
    return '#000000';
  }

  getColorForRig(data: any) {
    if (!data || !data.terrain) {
      return "#d1cccc";
    }
    const setting = this.settingsRig.find((x:any) => x.propertyName.toLowerCase() === data.terrain.toLowerCase());
    if (setting) {
      return setting.backgroundColor;
    }
    return "#d1cccc";
  }

  setupRigOptions() {
    let rigs = this.sequenceObject.rigs
    let allRigless = this.sequenceObject.riglessBuckets

    this.sortedRigs = [...rigs, ...allRigless]
    this.checkRigs = this.sortedRigs.map((thisRig: any, index: any) => {
      this.selected.push(index)
      if (thisRig.resourceType == 'RIG') {
        return { text: thisRig.name, value: index }
      } else {
        return { text: thisRig.alias, value: index }
      }

    })
  }

  setupWellOptions() {
    let allLandWells = this.$store.getters["wellsModule/getWellsByTerrain"]("Land")
    let allSwampWells = this.$store.getters["wellsModule/getWellsByTerrain"]("Swamp")
    let allOffshoreWells = this.$store.getters["wellsModule/getWellsByTerrain"]("Offshore")

    this.sortedWells = [...allLandWells, ...allSwampWells, ...allOffshoreWells]

    this.checkWells = this.sortedWells.map((thisWell: any, index: any) => {
      this.selectedWells.push(index)
      return { text: thisWell.name, value: index }
    })
  }

  showRigProperties(obj: any) {
    this.$store.commit('setActivePane', 'rig-info');
    this.$store.commit('setRightPaneToTrue');
    const rig = this.$store.getters['rigsModule/getRigById'](obj.id);
    this.$store.commit('setCurrentRig', rig ? rig : obj);
  }

  showRigLessProperties(obj: any) {
    this.$store.commit('setActivePane', 'rigless-info');
    this.$store.commit('setRightPaneToTrue');
    this.$store.commit('setCurrentRiglessBucket', obj);
  }

  convertToInches(val: number) {
    return val / 96;
  }

  get selectedSequence() {
    return this.$store.getters['projectModule/getSelectedSequence']
  }

  get swapState() {
    return this.$store.state.projectModule.swapState
  }

  get dynamicStart() {
    return this.$store.getters['getDynamicStartDate']
  }

  get dynamicEnd() {
    return this.$store.getters['getDynamicEndDate']
  }

  @Watch("swapState")
  onSwapStateChanged(newVal: string) {
    if (this.selectedSequence.Id == this.sequenceId) {
      switch (newVal) {
        case SwapStates.MOVING_INTO_POSITIONS:
          if (this.chartOptions.constraints.cascadeEast) {
            this.allowCascadeStateBackup = "SWITCHED"
            this.chartOptions.constraints.cascadeEast = false
          }
          break;
        case SwapStates.SETTING_ACTUAL_PERIOD:
            this.chartOptions.constraints.cascadeEast = true;
          break;
        case SwapStates.SWAP_COMPLETED:
          if (this.allowCascadeStateBackup == "SWITCHED") {
            this.$nextTick(() => this.chartOptions.constraints.cascadeEast = true)
          }
          break;
      }
    }
  }

  @Watch('selectedWellActivities', { immediate: true })
  onselectedWellActivitiesChanged() {
    this.$emit('selected-well-activities', this.selectedWellActivities);
  }

  @Watch('selectedLease', { immediate: true })
  onSelectedLeaseChanged() {
    this.projects = this.allProjects.filter((project: any) => this.selectedLease.includes(project.well.leaseId));
    const rigIds = [...new Set(this.projects.map((project: any) => project.rig.id))]
    const rigs = this.filteredRigs.filter((rig: any) => rigIds.includes(rig.id))
    this.filteredProjectsRigs = rigs;
  }

  @Watch('selected', { immediate: true })
  onSelectedChanged() {
    this.filteredProjectsRigs = this.filteredRigs;
  }

  @Watch('allProjects', { immediate: true })
  onAllProjectLoad() {
    this.projects = this.allProjects;
  }

  @Watch('showWBS')
  onShowWBSChanged(value: boolean) {
    if (!value) {
      this.selectedWellActivities = [];
    }
  }

  //watchers
  @Watch("dynamicStart")
  onDynamicStartChanged() {
    if (this.selectedSequence.Id == this.sequenceId)
      this.start = this.dynamicStart
  }

  @Watch("dynamicEnd")
  onDynamicEndChanged() {
    if (this.selectedSequence.Id == this.sequenceId)
      this.end = this.dynamicEnd
  }

  @Watch("currentHeight")
  currentHieghtWatcher(newVal: any) {
    if (this.$refs && this.$refs.gantt) {
      ((this.$refs.gantt) as any).resize();
      ((this.$refs.gantt) as any).adjustScaleX();
    }
  }

  @Watch("currentWidth")
  currentWidthWatcher(newVal: any) {
    if (this.$refs && this.$refs.gantt) {
      ((this.$refs.gantt) as any).resize();
      ((this.$refs.gantt) as any).adjustScaleX();
    }
  }

  @Watch("rightPane")
  onRightPaneChanged() {
    setTimeout(() => {
      if (this.$refs && this.$refs.gantt) {        
        ((this.$refs.gantt) as any).resize();
        ((this.$refs.gantt) as any).adjustScaleX();
      }
    }, 400);
  }

  updateGantt() {
    if (this.$refs && this.$refs.gantt) {
      ((this.$refs.gantt) as any).resize();
      ((this.$refs.gantt) as any).adjustScaleX();
    }
  }

  created() {
    if (this.settingsProject.length < 1 || this.settingswellFluid.length < 1)
    {
        this.fetchColorSettings.then(() => { })
    }
    this.filterId = Math.abs((Math.floor(Math.random() * (10 - +4000)) + 10) + (Math.floor(Math.random() * (10 - +4000)) + 10)).toString()
  }


  mounted() {
    tooltip = this.$refs.tooltip as any

    if (!this.activeUser  || this.activeUser === null){
        this.$store.dispatch('usersModule/getUsers')
    }

    this.$store.dispatch('departmentModule/getDepartments')

    if ((this.$store.getters['rigsModule/getAllrigs']).length <= 0) {
      this.$store.dispatch('rigsModule/getRigs')
    }

    if (this.$store.state.wellsModule.wells.length <= 0) {
      this.$store.dispatch('wellsModule/getWellsAction')
    }

    if (Object.entries(this.sequenceObject).length === 0) {
      this.$store.dispatch("sequencesModule/fetchSequences", this.sequenceId).then(res => {
        this.setupRigOptions()
        this.setupWellOptions()
        this.start = new Date(this.sequenceObject.startYear, 0, 1)
        this.end = new Date(this.sequenceObject.endYear, 11, 1)
      })
    } else {
      this.setupRigOptions()
      this.setupWellOptions()
      this.start = new Date(this.sequenceObject.startYear, 0, 1)
      this.end = new Date(this.sequenceObject.endYear, 11, 1)
    }

    // if (this.projects.length < 1) {
    //   this.$store.dispatch("projectModule/getProjectsForSequence", this.sequenceId)
    // }
    this.$store.dispatch("projectModule/getProjectsForSequence", this.sequenceId)

    this.$emit('show-funding', this.showFundingMechnism)
    this.filteredProjectsRigs = this.filteredRigs;
  }

  print() {
    return printer(this.sequenceObject, this.settingsTime, this.settingswellFluid, this.settingsRig, this.$store.getters['getDynamicStartDate'], this.sequenceObject.startYear, this.sequenceObject.endYear, this.getProjectsForYear, this.getProjectsForRig, this.getProjectsForRigless)
  }

  updated() {
    setTimeout(() => {
      if (this.$refs && this.$refs.gantt) {
        ((this.$refs.gantt) as any).resize();
        ((this.$refs.gantt) as any).adjustScaleX();
      }
    }, 500);
  }
}
